import Select from "./../../components/Select";
import { CiCreditCardOff, CiDeliveryTruck } from "react-icons/ci";
import { FaCartPlus } from "react-icons/fa";
import Button from "./../../components/Button";
import { Link } from "react-router-dom";

const ProductMainDetails = () => {
  const productTypes = [
    {
      id: 0,
      value: "original",
      text: "Original",
    },
    {
      id: 1,
      value: "gluten-free",
      text: "Gluten Free",
    },
    {
      id: 2,
      value: "sugar-free",
      text: "Sugar Free",
    },
  ];
  return (
    <div>
      <div className="flex flex-col text-[#828282] text-sm">
        <div className="title text-[23px] font-medium text-black">
          <h2>HappyNow Box - 3 Monthly Box</h2>
        </div>
        <div className="desc py-4">
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Numquam,
            sapiente illo. Sit error voluptas repellat rerum quidem, soluta enim
            perferendis voluptates laboriosam. Distinctio, officia quis dolore
            quos sapiente tempore alias.
          </p>
        </div>
        <div className="price flex flex-col mb-1">
          <span className="previous-price text-black line-through">₺199</span>
          <span className="current-price text-[#e66553] text-3xl font-semibold">
            ₺99
          </span>
        </div>
        <div className="product-types pt-1 pb-4">
          <div className="flex flex-col">
            <span className="pb-2">Dietary requirements</span>
            <span>
              <Select options={productTypes} />
            </span>
          </div>
        </div>
        <div className="features flex flex-wrap mb-4">
          <div className="single-feature ml-4 first:ml-0">
            <div className="flex items-center text-sm">
              <span className="text-2xl">
                <CiDeliveryTruck />
              </span>
              <span className="ml-2">Free shipping</span>
            </div>
          </div>
          <div className="single-feature ml-4 first:ml-0">
            <div className="flex items-center text-sm">
              <span className="text-2xl">
                <CiCreditCardOff />
              </span>
              <span className="ml-2">Cancel Anytime</span>
            </div>
          </div>
        </div>
        <div className="add-to-cart">
          <Link to="/everyone/shop/cart">
            <Button isHovered width={"w-full"}>
              <div className="flex items-center">
                <span className="">
                  <FaCartPlus />
                </span>
                <span className="pl-2">Add to Cart</span>
              </div>
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProductMainDetails;
